module.exports = __webpack_public_path__ + "static/media/MLH.842d65e7.svg";